import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "../context/LangContext";
import { waLink } from "../lib/site";

const FLOAT_INITIAL = { scale: 0, opacity: 0 };
const FLOAT_ANIMATE = { scale: 1, opacity: 1 };
const FLOAT_TRANSITION = { delay: 1.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] };
const FLOAT_HOVER = { scale: 1.06 };

export const WhatsAppFloat = () => {
  const { lang } = useLang();
  return (
    <motion.a
      href={waLink(lang)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      initial={FLOAT_INITIAL}
      animate={FLOAT_ANIMATE}
      transition={FLOAT_TRANSITION}
      whileHover={FLOAT_HOVER}
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-copper border border-copper flex items-center justify-center text-white shadow-[0_10px_30px_rgba(184,90,42,0.35)] hover:bg-copper-light transition-colors duration-500"
    >
      <MessageCircle size={22} strokeWidth={1.5} />
    </motion.a>
  );
};
